import { BREAKPOINTS } from '@/core/constants';
import { useMatchesMediaQueryWithResize } from '@/hooks/useMatchesMediaQueryWithResize';

export const useIsDesktopWithResize = () => {
  return useMatchesMediaQueryWithResize({
    query: `(min-width: ${BREAKPOINTS.lg}px)`,
  });
};
